angular.module('signalview.typeahead', []);
